"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTokenRegisterBody = void 0;
const validation_1 = require("@fmtk/validation");
const RegisterBody_1 = require("./RegisterBody");
exports.validateTokenRegisterBody = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
    familyName: (0, validation_1.text)(),
    givenName: (0, validation_1.text)(),
    password: (0, validation_1.text)(undefined, RegisterBody_1.MinimumPasswordLength),
});
//# sourceMappingURL=TokenRegisterBody.js.map